//Bibliotecas
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
//Componentes material
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
//Componentes
import Layout from './Layout';
import VitalizePaper from '../components/VitalizePaper';
import AvaliacaoSecao from '../components/avaliacao/AvaliacaoSecao';
import ConfirmDialog from '../components/ConfirmDialog';
import LoadingButton from '../components/LoadingButton';
import LabelSecao from '../components/LabelSecao';
import VitalizeFab from '../components/VitalizeFab';
//Controllers
import AvaliacaoController from '../controllers/AvaliacaoController';
//Modelos
import Avaliacao, { STATUS_INICIADA } from '../models/Avaliacao';
import AvaliacaoSecaoModel from '../models/AvaliacaoSecao';
//Utils
import deepCopy from '../utils/deepCopy';


//Definindo estilos para o componente
const styles = (theme) => ({
    errorLabel: {
        color: theme.palette.error.main
    }
});

class AvaliacaoEditPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleFinalizarClick = this.handleFinalizarClick.bind(this);
        this.handleSecaoChange = this.handleSecaoChange.bind(this);
        this.handleConfimClose = this.handleConfimClose.bind(this);
        //Controllers
        this.avaliacaoController = new AvaliacaoController();
        //Estado inicial
        this.state = {
            avaliacao: null,
            secaoAtual: 0,
            sucesso: false,
            processando: false,
            carregando: true,
            confirmarFinalizacao: false,
            erros: {
                erroAvaliacao: '',
                erroSecoes: ''
            },
            errosSecao: {
                respostas: []
            }
        };
    }

    /**
     * Obtém os dados da avaliação
     */
    async componentDidMount() {
        //Cria uma cópia do estado inicial
        const state = deepCopy(this.state);
        state.carregando = false; //Indica que a consulta terminou
        //Carrega a avaliação da API
        const id = this.getId();
        const result = await this.avaliacaoController.obter(id);
        //Atualiza os dados da avaliação
        if (result.sucesso)
            state.avaliacao = result.avaliacao;
        this.setState(state);
    }

    /**
     * Recupera o Id do cliente a ser editado dos parâmetros da URL
     * @returns {Number} Id da avaliação sendo editada
     */
    getId() {
        let id;
        if (this.props.match)
            id = this.props.match.params.id;
        return parseInt(id);
    }

    /**
     * Evento disparado quando o usuário pressiona o botão para ir para a seção anterior
     */
    async handlePreviousClick() {
        //Verifica se existe uma seção anterior
        const secaoAtual = this.state.secaoAtual;
        if (secaoAtual > 0) {
            //Somente se a avaliação estiver sendo preenchida
            if (this.state.avaliacao.status === STATUS_INICIADA)
                await this.salvarSecao(-1);//Salva a seção e altera a atual
            else
                this.setState({ secaoAtual: secaoAtual - 1 });
        }
    }

    /**
     * Evento disparado quando o usuário pressiona o botão para ir para a próxima seção
     */
    async handleNextClick() {
        //Verifica se há uma próxima seção
        const secaoAtual = this.state.secaoAtual;
        if (secaoAtual < this.state.avaliacao.secoes.length - 1) {
            //Somente se a avaliação estiver sendo preenchida
            if (this.state.avaliacao.status === STATUS_INICIADA)
                await this.salvarSecao(+1);//Salva a seção e altera a atual
            else
                this.setState({ secaoAtual: secaoAtual + 1 });
        }
    }

    /**
     * Evento disparado quando o usuário pressiona o botão para finalizar a avaliação
     */
    async handleFinalizarClick() {
        //Exibe o diálogo de confirmação
        this.setState({ confirmarFinalizacao: true });
    }

    /**
     * Evento disparado quando o diálogo de confirmação é fechado
     * @param {Boolean} confirm Indica se o usuário confirmou ou não o diálogo
     */
    handleConfimClose(confirm) {
        //Se o usuário confirmou, finaliza a avaliação
        if (confirm)
            this.finalizarAvaliacao();
        else //Caso contrário, apenas fecha o diálogo
            this.setState({ confirmarFinalizacao: false });
    }

    /**
     * Trata o evento de alteração de seção
     * @param {AvaliacaoSecaoModel} secao Seção alterada
     */
    handleSecaoChange(secao) {
        //Somente altera se a avaliação não estiver finalizada
        if (this.state.avaliacao.status === STATUS_INICIADA) {
            //Realiza uma cópia da avaliação
            const avaliacao = Avaliacao.clone(this.state.avaliacao);
            //Altera a seção
            avaliacao.secoes[this.state.secaoAtual] = AvaliacaoSecaoModel.clone(secao);
            //Atualiza o estado
            this.setState({ avaliacao });
        }
    }

    /**
     * Finaliza a avaliação e salva a última seção
     */
    async finalizarAvaliacao() {
        //Exibe loader
        this.setState({ processando: true, confirmarFinalizacao: false });
        const secaoAtual = this.state.secaoAtual;
        const secao = this.state.avaliacao.secoes[secaoAtual];
        //Envia a requisição para a API
        const result = await this.avaliacaoController.atualizar({ id: this.state.avaliacao.id, status: 'finalizada', secoes: [secao] });
        //Atualiza o estado da página de acordo com o retorno
        if (result.sucesso) {
            this.setState({ processando: false, sucesso: true, errosSecao: { respostas: [] }, confirmarFinalizacao: false });
        } else {
            this.setState({ processando: false, errosSecao: result.erros.secoes[0], confirmarFinalizacao: false });
        }
    }

    /**
     * Salva os dados da seção e altera o índica para a próxima a ser editada
     * @param {Number} proximoIndice Valor a ser acrescentado ao índice atual da seção (Pode ser +1 ou -1)
     */
    async salvarSecao(proximoIndice) {
        //Exibe loader
        this.setState({ processando: true });
        const secaoAtual = this.state.secaoAtual;
        const secao = this.state.avaliacao.secoes[secaoAtual];
        //Envia os dados para a API
        const result = await this.avaliacaoController.atualizar({ id: this.state.avaliacao.id, secoes: [secao] });
        //Atualiza o estado da página de acordo com o retorno
        if (result.sucesso) {
            this.setState({ processando: false, secaoAtual: secaoAtual + proximoIndice, errosSecao: { respostas: [] }, erros: { erroAvaliacao: '', erroSecoes: '' } });
        } else {
            this.setState({ processando: false, errosSecao: result.erros.secoes[0], erros: { erroAvaliacao: result.erros.erroAvaliacao, erroSecoes: result.erros.erroSecoes } });
        }
    }

    /**
     * Renderiza o botão 'Voltar' ou 'Anterior' de acordo com o estado da página
     * @param {Boolean} primeiraSecao Indica se a seção atual é a primeira da avaliação
     * @param {Boolean} ultimaSecao Indica se a seção atual é a última da avaliação
     * @param {Boolean} processando Indica se o componente está processando
     * @returns {Object} Retorna o botão apropriado
     */
    renderBotaoAnterior(primeiraSecao, ultimaSecao, processando) {
        if (primeiraSecao) {
            //Botão para voltar para a listagem
            return (<Button variant="text" color="inherit" component={Link} to="/avaliacao">Voltar</Button>);
        } else {
            //Botão para voltar para a seção anterior
            return (<LoadingButton variant="text" color="inherit" type="button" onClick={this.handlePreviousClick} loading={processando}>Anterior</LoadingButton>);
        }
    }

    /**
     * Renderiza o botão 'Próximo' ou 'Finalizar' de acordo com o estado da página
     * @param {Boolean} ultimaSecao Indica se a seção atual é a última da avaliação
     * @param {Boolean} processando Indica se o componente está processando
     * @returns {Object} Retorna o botão apropriado
     */
    renderBotaoProximo(ultimaSecao, processando) {
        if (ultimaSecao) {
            //Somente se a questão estiver sendo preenchida
            if (this.state.avaliacao.status === STATUS_INICIADA)
                //Botão para finaliza a avaliação
                return (<VitalizeFab color="primary" variant="extended" onClick={this.handleFinalizarClick} loading={processando}>Finalizar</VitalizeFab>);
            else
                //Exibe apenas o botão de voltar no topo
                return (<VitalizeFab color="primary" variant="extended" to="/avaliacao" >Voltar</VitalizeFab>);
        } else {
            //Botão para ir para a próxima seção
            return (<VitalizeFab color="primary" variant="extended" onClick={this.handleNextClick} loading={processando}>Próxima</VitalizeFab>);
        }
    }

    render() {
        const { onLogout, classes, usuario, empresa, permissoes } = this.props;
        const { avaliacao, secaoAtual, sucesso, errosSecao, erros, confirmarFinalizacao, processando, carregando } = this.state;

        if (sucesso)
            return <Redirect to={`/avaliacao/resultado?cliente=${avaliacao.cliente.id}&questionario=${avaliacao.questionario.id}&quantidade=5`} />;

        if (carregando)
            return (<Layout onLogout={onLogout} returnLink="/avaliacao" usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando}>Carregando questões...</Layout>);

        if (avaliacao === null)
            return (
                <Layout onLogout={onLogout} returnLink="/avaliacao" usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando}>
                    <VitalizePaper>
                        <Typography>Avaliação não encontrada</Typography>
                    </VitalizePaper>
                </Layout>
            );

        const { secoes, questionario, cliente } = avaliacao;

        const secao = secoes[secaoAtual];
        const primeiraSecao = secaoAtual === 0;
        const ultimaSecao = secaoAtual === secoes.length - 1;

        return (
            <Layout onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes} rightButton={this.renderBotaoAnterior(primeiraSecao, ultimaSecao, processando)} >
                <VitalizePaper>
                    <Grid container spacing={1} >
                        <Grid container item xs={12} >
                            <Grid item xs >
                                <LabelSecao label='Avaliação' />
                            </Grid>
                            <Grid item >
                                <Button variant="contained" color="primary" component={Link} to={`/avaliacao/resultado?avaliacoes[]=${avaliacao.id}`}>Resultado</Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <Typography>Questionário: {questionario.titulo}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <Typography>Formando: {cliente.nome}</Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography className={classes.errorLabel}>{erros.erroAvaliacao}</Typography>
                            <Typography className={classes.errorLabel}>{erros.erroSecoes}</Typography>
                        </Grid>
                    </Grid>
                </VitalizePaper>
                <AvaliacaoSecao secao={secao} erros={errosSecao} onChange={this.handleSecaoChange} />
                {this.renderBotaoProximo(ultimaSecao, processando)}
                <ConfirmDialog titulo="Deseja finalizar a avaliação? Não será possível alterar as respostas depois." open={confirmarFinalizacao} onClose={this.handleConfimClose} />
            </Layout>
        );
    }
}

AvaliacaoEditPage.propTypes = {
    /** Evento disparado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Parâmetros da URL */
    match: PropTypes.shape({
        params: PropTypes.shape({
            /** Id do cliente a ser editado */
            id: PropTypes.string
        })
    }),
    /** Classes CSS da página */
    classes: PropTypes.shape({
        errorLabel: PropTypes.string
    })
};

export default withStyles(styles)(AvaliacaoEditPage);